// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DockerIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 15">
    <path
      fill="#364548"
      fillRule="evenodd"
      d="M13.88 4.8h2.15V7h1.09a5 5 0 0 0 2.22-.58c-.3-.4-.46-.9-.5-1.39-.07-.67.07-1.54.52-2.07l.23-.26.27.22c.68.54 1.25 1.3 1.35 2.17a3.3 3.3 0 0 1 2.5.23l.29.18-.16.3c-.6 1.19-1.88 1.56-3.12 1.5-1.87 4.63-5.92 6.83-10.84 6.83-2.54 0-4.87-.95-6.2-3.2l-.02-.04-.2-.4c-.44-.99-.59-2.08-.49-3.16L3 7h1.84V4.8H7V2.65h4.3V.5h2.59z"
      clipRule="evenodd"
    />
    <path
      fill="#22A0C8"
      fillRule="evenodd"
      d="M20.85 5.62c.14-1.12-.7-2-1.22-2.42-.6.69-.69 2.5.25 3.27-.52.47-1.63.9-2.76.9H3.32q-.15 1.77.58 3.2l.16.28q.14.25.32.49.86.06 1.57.04 1.4-.03 2.29-.34a.17.17 0 0 1 .1.32l-.24.07a7 7 0 0 1-1.62.27h-.07a14 14 0 0 1-1.72 0c1.14 1.3 2.94 2.07 5.2 2.07 4.76 0 8.8-2.11 10.59-6.86 1.27.13 2.49-.2 3.05-1.27a3 3 0 0 0-2.68-.02"
      clipRule="evenodd"
    />
    <path
      fill="#37B1D9"
      fillRule="evenodd"
      d="M20.85 5.62c.14-1.12-.7-2-1.22-2.42-.6.69-.69 2.5.25 3.27-.52.47-1.63.9-2.76.9H4.14c-.05 1.8.62 3.18 1.8 4q1.43-.02 2.3-.33a.17.17 0 0 1 .1.32l-.24.07q-.68.2-1.62.27l-.01-.01c1.62.83 3.97.83 6.67-.2a19 19 0 0 0 7.8-5.91q-.04 0-.1.04"
      clipRule="evenodd"
    />
    <path
      fill="#1B81A5"
      fillRule="evenodd"
      d="M3.35 8.8q.14.95.55 1.76l.16.3q.14.24.32.48.86.06 1.57.04 1.4-.03 2.29-.34a.17.17 0 0 1 .1.32l-.23.07q-.69.2-1.63.27H6.4a14 14 0 0 1-1.73 0c1.15 1.3 2.96 2.07 5.21 2.07 4.08 0 7.63-1.55 9.7-4.97z"
      clipRule="evenodd"
    />
    <path
      fill="#1D91B4"
      fillRule="evenodd"
      d="M4.27 8.8a4.1 4.1 0 0 0 1.68 2.58q1.4-.03 2.29-.34a.17.17 0 0 1 .1.32l-.23.07q-.69.2-1.64.27c1.62.83 3.97.82 6.67-.22a18 18 0 0 0 4.6-2.68z"
      clipRule="evenodd"
    />
    <path
      fill="#23A3C2"
      fillRule="evenodd"
      d="M5.2 5.16h1.86v1.87H5.2zm.16.16h.14v1.55h-.14zm.27 0h.16v1.55h-.16zm.28 0h.16v1.55H5.9zm.29 0h.15v1.55H6.2zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zM7.36 3h1.86v1.86H7.35zm.15.16h.14v1.55h-.14zm.27 0h.16v1.55h-.16zm.29 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15z"
      clipRule="evenodd"
    />
    <path
      fill="#34BBDE"
      fillRule="evenodd"
      d="M7.35 5.16h1.87v1.87H7.35zm.16.16h.14v1.55h-.14zm.27 0h.16v1.55h-.16zm.29 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15z"
      clipRule="evenodd"
    />
    <path
      fill="#23A3C2"
      fillRule="evenodd"
      d="M9.5 5.16h1.87v1.87H9.5zm.16.16h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.16v1.55h-.16zm.29 0h.14v1.55h-.14z"
      clipRule="evenodd"
    />
    <path
      fill="#34BBDE"
      fillRule="evenodd"
      d="M9.5 3.01h1.87v1.86H9.5zm.16.16h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.16v1.55h-.16zm.29 0h.14v1.55h-.14zm.58 2h1.87v1.86h-1.87zm.16.15h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.16v1.55h-.16zm.28 0h.16v1.55h-.16zm.29 0h.14v1.55h-.14z"
      clipRule="evenodd"
    />
    <path
      fill="#23A3C2"
      fillRule="evenodd"
      d="M11.65 3.01h1.87v1.86h-1.87zm.16.16h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.16v1.55h-.16zm.29 0h.14v1.55h-.14z"
      clipRule="evenodd"
    />
    <path
      fill="#34BBDE"
      fillRule="evenodd"
      d="M11.65.86h1.87v1.86h-1.87zm.16.15h.15v1.56h-.15zm.28 0h.15v1.56h-.15zm.28 0h.15v1.56h-.15zm.28 0h.15v1.56h-.15zm.28 0h.16v1.56h-.16zm.29 0h.14v1.56h-.14z"
      clipRule="evenodd"
    />
    <path
      fill="#23A3C2"
      fillRule="evenodd"
      d="M13.8 5.16h1.87v1.87h-1.86zm.16.16h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15zm.28 0h.16v1.55h-.16zm.29 0h.15v1.55h-.15zm.28 0h.15v1.55h-.15z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECEC"
      fillRule="evenodd"
      d="M9.1 10.05a.51.51 0 1 1 .01 1.03.51.51 0 0 1-.01-1.03"
      clipRule="evenodd"
    />
    <path
      fill="#364548"
      fillRule="evenodd"
      d="M9.1 10.2q.08 0 .13.02a.15.15 0 0 0 .08.28q.08 0 .13-.08a.37.37 0 1 1-.34-.22M0 8.98h23.93c-.52-.13-1.65-.3-1.46-.99-.95 1.1-3.23.77-3.81.23-.64.93-4.38.58-4.64-.15-.8.95-3.3.95-4.1 0-.27.73-4 1.08-4.65.15-.57.54-2.86.87-3.8-.23.18.68-.95.86-1.47 1"
      clipRule="evenodd"
    />
    <path
      fill="#BDD9D7"
      fillRule="evenodd"
      d="M10.47 13.76a4.5 4.5 0 0 1-2.37-2.33q-.7.2-1.7.26a14 14 0 0 1-1.79 0c1.17 1.16 2.61 2.06 5.27 2.08z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECEC"
      fillRule="evenodd"
      d="M8.58 12.26a5 5 0 0 1-.47-.83q-.72.2-1.7.26c.45.25 1.1.48 2.17.57"
      clipRule="evenodd"
    />
  </svg>,
  "Docker",
);
export default DockerIcon;
